export default __webpack_public_path__ + "static/media/createYourOwn.b48bf8f5.svg";